// extracted by mini-css-extract-plugin
module.exports = {"calculatorForm__label":"CalculatorForm_calculatorForm__label__wnNJo","calculatorForm__reportTypes":"CalculatorForm_calculatorForm__reportTypes__InWkI"};